module.exports = __webpack_public_path__ + "img/1.712750cc.jpg";